const enum DateFormat {
  DEFAULT = "DD.MM.YYYY HH:mm",
  ONLY_TIME = "HH:mm",
  ONLY_DATE = "DD.MM.YYYY",
  SHORT_DATE_TIME = "D.M.YYYY HH:mm",
}

export default DateFormat;
